var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-element-wrapper"},[_c('img',{attrs:{"src":_vm.imageUrl},on:{"load":_vm.onImageLoaded,"click":_vm.handlePreview}}),(_vm.showProgressBar)?_c('a-progress',{attrs:{"percent":_vm.percent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }